import '@mantine/core/styles.css';
import '@mantine/charts/styles.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { appStarted, initBrandingPreview, isPreviewMode } from '@buildex/core';
import { initI18n } from './app/i18n';
import { App } from './app/App';
import { ALLOWED_PREVIEW_ORIGINS } from './app/config';

initI18n();

// Кабинет в iframe админки (?previewMode=1) слушает BRANDING_PREVIEW (§8)
if (isPreviewMode()) {
  initBrandingPreview(ALLOWED_PREVIEW_ORIGINS);
}

appStarted();

const rootElement = document.getElementById('root');
if (rootElement === null) {
  throw new Error('#root not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
